import { Component, OnInit, Input } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';

@Component({
  selector: 'app-bulletins',
  templateUrl: './bulletins.component.html',
  styleUrls: ['./bulletins.component.css']
})
export class BulletinsComponent implements OnInit {
  constructor( private homepageService: HomepageService ) {}
	bulletinlist: any = [];
	@Input() size: number;
  @Input() buId: number;
	 ngOnInit() { 
      	this.getBulletinlist();
 	} 	
 	getBulletinlist(){
     let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
     getwidgetsSettingDataSave.data.forEach(evt => {
            if(evt.code == 'BL' && this.buId  == evt.id){
               this.bulletinlist = evt.content;              
             }
            
          });
    }

}
